import { motion } from 'framer-motion';
import { getRegisterLink } from '../config/externalLinks';

export function HeroSection() {
  const registerLink = getRegisterLink();

  return (
    <section id="inicio" className="scroll-mt-24">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-8 px-4 pb-8 pt-10 sm:px-6 lg:grid-cols-2 lg:gap-10 lg:px-8 lg:pb-10">
        <div className="flex flex-col items-start text-left">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="max-w-xl font-display text-4xl font-extrabold leading-tight text-brand-yellow sm:text-5xl lg:max-w-none"
          >
            La plataforma más completa para organizar tus competencias deportivas
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.28, duration: 0.5 }}
            className="mt-5 max-w-xl text-sm text-zinc-300 sm:text-base"
          >
            Más organización. Menos planillas.
            <br />
            Más profesionalismo. ¡Todo en un solo lugar!
          </motion.p>

          <div className="mt-8 flex flex-wrap items-center justify-start gap-3">
            <button
              onClick={() => {
                window.open(registerLink, '_blank', 'noopener,noreferrer');
              }}
              className="action-btn bg-brand-yellow text-black hover:bg-brand-yellow/85"
            >
              Crear Torneo GRATIS
            </button>
            <button
              type="button"
              onClick={() => {
                window.open('https://www.youtube.com/@protorneos', '_blank', 'noopener,noreferrer');
              }}
              className="action-btn bg-transparent text-brand-yellow hover:bg-brand-yellow hover:text-black"
            >
              Ver DEMO
            </button>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, x: 28 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.55 }}
          className="relative mx-auto flex w-full max-w-sm items-center justify-center sm:max-w-md lg:max-w-none"
        >
          <img
            src={`${process.env.PUBLIC_URL}/hero.pro-19.svg`}
            alt="Personas usando Protorneos en dispositivos"
            className="block h-auto w-full max-h-[220px] object-contain object-center sm:max-h-[300px] lg:max-h-[420px] xl:max-h-[480px]"
            width={1930}
            height={1287}
            decoding="async"
          />
        </motion.div>
      </div>
    </section>
  );
}
